var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"test-modal","resizable":true,"height":'auto',"width":'100%',"scrollable":true}},[_vm._v(" TEST ")])
}
var staticRenderFns = []

export { render, staticRenderFns }